<ng-container *ngIf="{
    row: columnData | async
  } as $">
  <span class="bg-{{$.row.TypeColor.toLowerCase()}}-400 text-white uppercase text-xs border-round py-1 px-2">{{$.row.Type}}</span>
  <strong  *ngIf="$.row" class="text-{{$.row.TypeColor.toLowerCase()}}-400 font-bold ml-2">{{$.row.TypeName}}</strong>
</ng-container>
